<template>
  <div class="loader-container" v-if="active">
    <loader :active="true"/>
  </div>
</template>

<script setup lang="ts">

import Loader from "@/components/Loader.vue";

const props = defineProps({
  active: Boolean,
});
</script>

<style lang="scss">
.loader-container {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 1rem;
  background: #f0f1f2;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
  z-index: 1051;

  & > .loader-wrapper {
    height: 32px;
    width: 32px;

    & > div {
      border-width: 4px;
    }
  }
}
</style>
